import { render, staticRenderFns } from "./edit-userexpressinfo.vue?vue&type=template&id=d83d4ee8&scoped=true&"
import script from "./edit-userexpressinfo.vue?vue&type=script&lang=ts&"
export * from "./edit-userexpressinfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83d4ee8",
  null
  
)

export default component.exports